/* eslint-disable react/prop-types */
import React from 'react';
import CheckboxV2 from '../../../controls/CheckboxV2/CheckboxV2';
import FormInputContainer from '../../../scaffolding/FormInputContainer/FormInputContainer';
import { CheckContainerV2 } from './CheckboxWithLabelV2Styles';

const CheckboxWithLabelV2 = ({
  id,
  value,
  label,
  onClick,
}) => (
  <FormInputContainer>
    <CheckContainerV2 id={`${id}_container`}>
      <CheckboxV2
        id={id}
        height={16}
        width={16}
        onClick={onClick}
        checked={value}
      />

      <label id={`${id}_label`} className="checkboxLabel" htmlFor={id}>
        {label}
      </label>
    </CheckContainerV2>
  </FormInputContainer>
);

export default CheckboxWithLabelV2;
